import { OnboardingRouteRedirect } from '../../components';

export default function Step5IncomeRedirect() {
  return <OnboardingRouteRedirect to="/(onboarding)/step-4-income" />;
}
